import React from 'react';
import { MdNotifications, MdPerson } from 'react-icons/md';
import { useAuth } from '../context/AuthContext';

const Header: React.FC = () => {
  const { user } = useAuth();

  return (
    <header className="flex h-20 items-center justify-between border-b border-gray-200 bg-white px-8 dark:border-navy-700 dark:bg-navy-800">
      {/* Page Title */}
      <div>
        <h1 className="text-2xl font-bold text-navy-800 dark:text-white">
          Admin Panel
        </h1>
        
      </div>

      {/* User Info */}
      <div className="flex items-center space-x-4">
        {/* Notifications */}
        <button className="relative rounded-lg p-2 text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-navy-700">
          <MdNotifications className="h-6 w-6" />
          <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-red-500"></span>
        </button>

        {/* User Profile */}
        <div className="flex items-center space-x-3 rounded-lg bg-gray-50 px-4 py-2 dark:bg-navy-700">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-brand-500 to-purple-600 text-white">
            <MdPerson className="h-6 w-6" />
          </div>
          <div>
            <p className="text-sm font-semibold text-navy-800 dark:text-white">
              {user?.first_name} {user?.last_name}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {user?.email}
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
